<template>
  <section class="sm:flex sm:items-center sm:justify-between">
    <div class="sm:flex sm:space-x-5 flex-col">
      <h1 class="flex flex-row items-center">
        <Twemoji :code="experiment.practice.emoji" class="w-12 h-12 mr-4 " />
        <span class="text-3xl font-bold text-white">
          {{ experiment.practice.title }}
        </span>
      </h1>
      <p class="text-lg text-white font-medium pl-10 pt-2 " v-if="experiment.alias">
        {{ experiment.alias }}
      </p>
    </div>
    <div class="mt-5 flex justify-center sm:mt-0">
      <ActionButton @click="onEval" class="mr-4">
        Zwischenauswertung
      </ActionButton>
    </div>
  </section>
  <section>
    <EvaluationModal ref="modal" :experiment="experiment" />
  </section>
</template>

<script setup>
import { ref } from 'vue';
const props = defineProps({experiment: Object});
const modal = ref();
const onEval = () => modal.value.show();
</script>
